import * as dateformat from "dateformat"
const DefaultDateFormat = "yyyy/mm/dd HH:MM"
export function formatDate(date: any, dateFormat: string = DefaultDateFormat): string {
    if (!(date instanceof Date)) {
        date = new Date(date)
    }
    return dateformat(date, dateFormat)
}